export default __webpack_public_path__ + "static/media/welcome-icon.202aeb83.webp";